import { ReactNode, useCallback } from 'react';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import type { BroadcastStatusTreesToClientsResponse } from 'common/status/BroadcastStatusTreesToClientDocument';
import type { StatusTree } from 'common/status/StatusTree';
import { useSocket } from 'client/lib/Socket';

export interface DeploymentStatusTreesState {
  statusTrees: {
    coreID: number;
    deploymentID: number;
    statusTree: StatusTree;
  }[];
}

const initialState: DeploymentStatusTreesState = {
  statusTrees: [],
};

export const useDeploymentStatusTreesState = create(combine(initialState, (set, get) => ({})));

export const useDeploymentStatusTree = (deploymentID: number | null | undefined) =>
  useDeploymentStatusTreesState((state) => state.statusTrees.find((item) => item.deploymentID === deploymentID)?.statusTree || null);

/** Handle updating the status tree data with HTTP & Socket requests */
export const StatusTreeProvider = ({ children }: { children?: ReactNode }) => {
  const handleDeploymentStatusTreesUpdateRequest = useCallback((payload: BroadcastStatusTreesToClientsResponse) => {
    const statusTrees = [...useDeploymentStatusTreesState.getState().statusTrees];

    //console.log('handleDeploymentStatusTreesUpdateRequest', payload);

    for (const coreTree of payload.statusTrees) {
      const index = statusTrees.findIndex((item) => item.deploymentID === coreTree.deploymentID);
      if (index < 0) {
        statusTrees.push(coreTree);
      } else {
        statusTrees.splice(index, 1, coreTree);
      }
    }

    useDeploymentStatusTreesState.setState({ statusTrees });
  }, []);

  useSocket({
    listeners: [
      {
        path: '/status/next-status-tree',
        handler: handleDeploymentStatusTreesUpdateRequest,
      },
    ],
  });

  if (!children) return null;
  return <>{children}</>;
};
